import React, { useState } from "react";

import Header from "../Homepage/Header";
import Footer from "../Homepage/Footer";

function Product(){
    return(
      <div className="body">
        <Header/>
        
        {/* <Footer/> */}
      </div>
    )
}

export default Product